import './_article-custom-html.scss';

export default () => {};
